import { TypedDocumentNode } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { Mutation } from 'graphql/generated/graphqlTypes';
import { GO_BACK_ONE_ONBOARDING_STEP } from 'graphql/mutations';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import { ignoreHandledMutationError } from 'utils/Mutation/ignoreHandledMutationError';
import { BaseHookProps } from '../shared/types';

// Typing the document (instead of passing generics to useMutation) avoids the deprecated useMutation signature.
const GO_BACK_ONE_ONBOARDING_STEP_TYPED: TypedDocumentNode<
  Pick<Mutation, 'goBackOneOnboardingStep'>,
  Record<string, never>
> = GO_BACK_ONE_ONBOARDING_STEP;

const useGoBackOneOnboardingStep = ({ handleFetchError }: BaseHookProps) => {
  const [goBackOneOnboardingStepMutation, { loading }] = useMutation(GO_BACK_ONE_ONBOARDING_STEP_TYPED, {
    onCompleted: (data) => {
      setCurrentTenantAction(data.goBackOneOnboardingStep);
    },
    onError: () => {
      handleFetchError('Error while going back one step');
    }
  });

  const goBackOneOnboardingStep = async () => {
    await ignoreHandledMutationError(goBackOneOnboardingStepMutation());
  };

  return {
    loading,
    goBackOneOnboardingStep
  };
};

export default useGoBackOneOnboardingStep;
